import { TranslationService } from '../../../../../services/translation.service';
import { createControlComponent } from '@react-leaflet/core';
import { ControlPosition } from 'leaflet';
import L from 'leaflet';

function CreateFilterControl({ className, position = 'bottomright', onClick }: { className: string; position?: ControlPosition; onClick?: () => void }) {
  const controlInstance = new L.Control({ position });
  controlInstance.onAdd = () => {
    const div = L.DomUtil.create('div', `leaflet-bar ${className ?? ''}`);
    const hyperlink = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single');
    hyperlink.title = TranslationService.get('common.map.togglefilters');
    hyperlink.setAttribute('role', 'button');
    hyperlink.setAttribute('aria-label', TranslationService.get('common.map.togglefilters'));
    hyperlink.onclick = (e) => {
      e.preventDefault();
      onClick?.();
    };
    hyperlink.innerHTML = '<span aria-hidden="true" class="leaflet-control-filter-icon"></span>';
    div.appendChild(hyperlink);
    return div;
  };

  return controlInstance;
}

const FilterControlComponent = createControlComponent(CreateFilterControl);

export default FilterControlComponent;
